// extracted by mini-css-extract-plugin
export default {"main":"Menu_main__ozMoU","mobileWrapper":"Menu_mobileWrapper__zDWtV"};